import Vue from 'vue'

Vue.filter('quote', (value) => {
    return "\"" + value + "\""
});

Vue.filter('dash', (value) => {
    return "— " + value
})
